var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalaMultipleWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SalaMultiple_White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 235.922,
    height: 235.931,
    viewBox: "0 0 235.922 235.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fbfaf1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-1",
    d: "M117.753,59.925a4.613,4.613,0,0,0-6.424,1.089l-.1.135a4.613,4.613,0,0,0,1.126,6.4,4.564,4.564,0,0,0,2.655.844,4.625,4.625,0,0,0,3.769-1.933l.086-.135A4.625,4.625,0,0,0,117.753,59.925Z",
    transform: "translate(24.696 13.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-1",
    d: "M113.591,70.747a4.613,4.613,0,0,0-6.485-.636A57.082,57.082,0,0,1,85.484,81.222a4.613,4.613,0,0,0,1.224,9.067,4.4,4.4,0,0,0,1.224-.159,66.394,66.394,0,0,0,25.1-12.9,4.613,4.613,0,0,0,.563-6.485Z",
    transform: "translate(18.36 15.446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-1",
    d: "M222.1,99.88a13.839,13.839,0,0,0-13.827,13.827v2.3a39.242,39.242,0,0,1-32.5,38.593,22.025,22.025,0,0,0,3.818-12.432v-3.206a22.221,22.221,0,0,0-44.43,0v3.206a22.111,22.111,0,0,0,3.671,12.151,39.23,39.23,0,0,1-31.068-38.312v-2.3a13.827,13.827,0,1,0-27.642,0v2.3a66.272,66.272,0,0,0,5.531,26.761H54.343V96.356A4.613,4.613,0,0,0,51,91.926,57.853,57.853,0,0,1,9.215,36.533v-2.3a4.613,4.613,0,0,1,9.214,0v2.3A48.431,48.431,0,0,0,66.811,84.915H89a48.431,48.431,0,0,0,48.382-48.382v-2.3a4.613,4.613,0,0,1,9.214,0v2.3A57.388,57.388,0,0,1,142.8,57.1a4.613,4.613,0,0,0,8.565,3.3,66.37,66.37,0,0,0,4.405-23.873v-2.3a13.827,13.827,0,0,0-27.654,0v2.3A39.156,39.156,0,0,1,95.652,75.126,22.025,22.025,0,0,0,99.47,62.694V59.488a22.209,22.209,0,1,0-44.418,0v3.206a22.025,22.025,0,0,0,3.671,12.163,39.242,39.242,0,0,1-31.08-38.324v-2.3A13.827,13.827,0,1,0,0,34.232v2.3A66.186,66.186,0,0,0,13.755,77.108,67.532,67.532,0,0,0,45.129,99.733v47.636a4.6,4.6,0,0,0,4.6,4.613h.844V226.8a4.613,4.613,0,0,0,9.214,0V151.982h30.86q1.505,2.349,3.23,4.589c.306.4.612.783.93,1.224v69a4.613,4.613,0,0,0,9.2,0V167.168a67.386,67.386,0,0,0,21.218,12.041V226.8a4.613,4.613,0,0,0,9.214,0V175.831a4.6,4.6,0,0,0-3.341-4.43,57.866,57.866,0,0,1-41.775-55.394v-2.3a4.613,4.613,0,1,1,9.214,0v2.3a48.444,48.444,0,0,0,48.395,48.382h22.172a48.444,48.444,0,0,0,48.382-48.382v-2.3a4.613,4.613,0,1,1,9.214,0v2.3a57.685,57.685,0,0,1-42.752,55.727,4.613,4.613,0,0,0-3.416,4.451v33.356a4.613,4.613,0,1,0,9.214,0V179.563a66.92,66.92,0,0,0,46.168-63.555v-2.3A13.839,13.839,0,0,0,222.1,99.88ZM64.254,59.5a12.995,12.995,0,0,1,25.99,0v3.206a12.995,12.995,0,1,1-25.99,0Zm106.113,82.681a13.007,13.007,0,0,1-26,0v-3.206a13.007,13.007,0,0,1,26,0Z",
    transform: "translate(0.005 4.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "cls-1",
    d: "M155.44,186.628a4.613,4.613,0,1,0,1.346,3.255A4.613,4.613,0,0,0,155.44,186.628Z",
    transform: "translate(33.005 41.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "cls-1",
    d: "M63.983,140.84a4.6,4.6,0,0,0-4.613,4.6V199.77a4.613,4.613,0,0,0,9.214,0V145.441A4.6,4.6,0,0,0,63.983,140.84Z",
    transform: "translate(13.283 31.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "cls-1",
    d: "M176.321,30.88a4.6,4.6,0,0,0-4.6,4.6V41.22a4.613,4.613,0,0,0,9.214,0V35.481A4.613,4.613,0,0,0,176.321,30.88Z",
    transform: "translate(38.408 6.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "cls-1",
    d: "M176.321,53.31a4.6,4.6,0,0,0-4.6,4.613V63.65a4.613,4.613,0,0,0,9.214,0V57.923A4.613,4.613,0,0,0,176.321,53.31Z",
    transform: "translate(38.408 11.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-1",
    d: "M190.933,44.441h-5.727a4.613,4.613,0,1,0,0,9.214h5.727a4.613,4.613,0,0,0,0-9.214Z",
    transform: "translate(40.339 9.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-1",
    d: "M168.543,44.441h-5.727a4.613,4.613,0,1,0,0,9.214h5.727a4.613,4.613,0,0,0,0-9.214Z",
    transform: "translate(35.332 9.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-1",
    d: "M83.65,0A4.613,4.613,0,0,0,79,4.613V10.34a4.613,4.613,0,0,0,9.214,0V4.613A4.6,4.6,0,0,0,83.65,0Z",
    transform: "translate(17.673 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-1",
    d: "M83.65,22.43A4.613,4.613,0,0,0,79,27.043V32.77a4.613,4.613,0,0,0,9.214,0V27.043A4.6,4.6,0,0,0,83.65,22.43Z",
    transform: "translate(17.673 5.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "cls-1",
    d: "M98.2,13.561H92.47a4.613,4.613,0,0,0,0,9.214H98.2a4.613,4.613,0,1,0,0-9.214Z",
    transform: "translate(19.707 3.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    className: "cls-1",
    d: "M75.766,13.561H70.04a4.613,4.613,0,0,0,0,9.214h5.727a4.613,4.613,0,1,0,0-9.214Z",
    transform: "translate(14.691 3.031)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaMultipleWhite);
export default __webpack_public_path__ + "static/media/SalaMultiple_White.534291ef51ba6d026315a31ee4a67430.svg";
export { ForwardRef as ReactComponent };